module.exports = __webpack_public_path__ + "static/media/所属乡镇.f4c4cc13.svg";